import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions, TextField } from "@material-ui/core";
import { CustomTextField } from "../../../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import { Editor } from "primereact/editor";
import { Autocomplete } from "@material-ui/lab";
import { formatDate, sendMessages } from "../../../../utils/utils";
import {
  getUsers,
  saveMessage,
  deleteMessage,
} from "../../../../services/usersService";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
const MessageForm = ({
  action,
  ticketID = 0,
  reply,
  forward,
  draft,
  sendToUsers,
  onReloadMessages,
  onCloseDialog,
}) => {
  const { auth } = store.getState();
  const [users, setUsers] = useState([]);
  const { socket } = useGlobalData();
  const { fullName } = auth.user;
  useEffect(() => {
    async function getUsersData() {
      const response = await getUsers();
      const { data } = response.data;
      setUsers(data.users);
    }
    getUsersData();
  }, []);
  let messageData = {
    ID: reply ? reply.ID : draft ? draft.ID : 0,
    ticketID: ticketID,
    subject:
      ticketID > 0
        ? "Message of Ticket ID " + ticketID
        : reply
        ? reply.subject
        : forward
        ? "Fwd: " + forward.subject
        : draft
        ? draft.subject
        : "",
    message: reply
      ? ReactDOMServer.renderToString(
          <React.Fragment>
            <br />
            <br />
            <br />
            <p>
              On {formatDate(reply.CreatedAt, true)}
              {`,`} {reply.fromUser.firstName} {reply.fromUser.lastName}{" "}
              {`<${reply.fromUser.username}>`} {`wrote:`}
            </p>
          </React.Fragment>
        ) +
        `<blockquote style="margin: 0px 0px 0px 0.8ex;border-left: 1px solid rgb(204, 204, 204);padding-left: 1ex;">` +
        `${reply.message}` +
        `</blockquote>`
      : forward
      ? ReactDOMServer.renderToString(
          <React.Fragment>
            <br />
            <br />
            <br />
            <p>---------- Forwarded message ---------</p>
            <p>
              <strong>From: </strong> {forward.fromUser.firstName}{" "}
              {forward.fromUser.lastName} {`<${forward.fromUser.username}>`}
            </p>
            <p>
              <strong>Date: </strong> {formatDate(forward.CreatedAt, true)}
            </p>
            <p>
              <strong>Subject: </strong> {forward.subject}
            </p>
            <p>
              <strong>To: </strong> {formatMessageTo(forward)}
            </p>
            <br />
          </React.Fragment>
        ) + `${forward.message}`
      : draft
      ? draft.message
      : "",
    toUsers: [],
    attachments: [],
  };

  if (typeof sendToUsers !== "undefined") {
    messageData.toUsers = messageData.toUsers.concat(sendToUsers);
  }

  const messageFormSchema = yup.object().shape({
    ID: yup.number(),
    subject: yup.string().required("Subject is Required"),
    message: yup.string().required("Message is Required"),
    toUsers: yup.array().required("To Users is Required"),
  });

  return (
    <Formik
      initialValues={messageData}
      enableReinitialize={true}
      validationSchema={messageFormSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        if (action === "reply") {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to reply this Message ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, reply it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveMessage("reply", values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Replied",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  sendMessages(socket, fullName, values.toUsers);
                  resetForm();
                  if (onReloadMessages != null) {
                    onReloadMessages();
                  }
                  onCloseDialog();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        } else if (action === "forward") {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to forward this Message ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, forward it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveMessage("sent", values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Forwarded",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  sendMessages(socket, fullName, values.toUsers);
                  resetForm();
                  if (onReloadMessages != null) {
                    onReloadMessages();
                  }
                  onCloseDialog();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        } else if (action === "compose-draft") {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to send this Message ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, send it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                if (values.ID > 0) {
                  deleteMessage("permanent-drafts", values.ID);
                  values.ID = 0;
                }
                saveMessage("sent", values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Sent",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  resetForm();
                  if (onReloadMessages != null) {
                    onReloadMessages();
                  }
                  onCloseDialog();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        } else {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to send this Message ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, send it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveMessage("sent", values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Sent",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  sendMessages(socket, fullName, values.toUsers);
                  resetForm();
                  if (onReloadMessages != null) {
                    onReloadMessages();
                  }
                  onCloseDialog();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          {ticketID === 0 ? (
            <CustomTextField
              label="Subject"
              inputType="text"
              propertyName="subject"
              onBlur={handleBlur}
              onChange={handleChange}
              values={values}
              touched={touched}
              errors={errors}
              size="small"
              endAdornment={{
                readOnly:
                  action === "reply" || action === "forward" ? true : false,
              }}
            />
          ) : null}

          <Autocomplete
            multiple
            id="toUsers"
            options={users}
            value={values.toUsers}
            onBlur={handleBlur}
            onChange={(event, value) => {
              setFieldValue("toUsers", value);
            }}
            getOptionLabel={(option) =>
              option.firstName + " " + option.lastName
            }
            filterSelectedOptions
            getOptionSelected={(option, value) =>
              option.username === value.username
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="To Users"
                placeholder="Users"
                size="small"
                helperText={touched.toUsers && errors.toUsers}
                error={Boolean(touched.toUsers && errors.toUsers)}
              />
            )}
          />
          <br />
          <Editor
            style={{ height: "240px", width: "100%" }}
            onTextChange={(e) => {
              setFieldValue("message", e.htmlValue);
            }}
            value={values.message}
            placeholder="Type your messages here..."
          />

          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                if (values.ID > 0) {
                  values.toUsers = [];
                  values.toUsers = draft.toUsers;
                } else if (values.ID === 0) {
                  values.toUsers = [];
                }
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                })
                  .fire({
                    title: "Are you sure want to save this Draft Message ?",
                    text:
                      "Please note that you are responsible for this action",
                    icon: "question",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                    cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                    reverseButtons: true,
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      saveMessage("drafts", values).then((response) => {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Saved",
                          html: response.data.message,
                          icon: "success",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                        if (onReloadMessages != null) {
                          onReloadMessages();
                        }
                        onCloseDialog();
                      });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Cancelled",
                        text: "No change has been made",
                        icon: "info",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    }
                  });
              }}
              className="btn btn-warning btn-md btn-pill btn-bold"
            >
              <i className="fab fa-firstdraft"></i>
              Save Draft
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-paper-plane"></i>
              Send
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
  function formatMessageTo(message) {
    let messageTo = "";
    message.toUsers
      .filter((person) => person.statusID !== 3)
      .map((user, index) => {
        messageTo += `${user.toUser.username}`;
        if (message.toUsers.length - 1 !== index) {
          messageTo += `, `;
        }
      });
    return messageTo;
  }
};

export default MessageForm;
